import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#4C1B72",
      light: "#DAD9DC",
    },
    secondary: {
      main: "#11cb5f",
    },
    error: {
      main: "#E64E47",
    },
  },
});
